import Attachment from './container/index';

export default Attachment;



// WEBPACK FOOTER //
// ./src/views/Attachment/index.js